/* CARLA HOME — Product finder (quiz). Una sola lógica para todos los finders; cada página trae su configuración en JSON. */
(function () {
  'use strict';

  var COLOR_SUFFIX = /\s*[-,]\s*(Black|White|Grey|Gray|Beige|Brown|Natural|Oak|Silver|Green|Pink|Blue)\s*$/i;
  var SWATCH = { Black: '#2A2A2A', White: '#F4F2EE', Grey: '#9A9893', Beige: '#D9C7AE', Brown: '#7A5A3E', Natural: '#C8A97E', Oak: '#B08A5E', Silver: '#C9CBCD', Green: '#7FA37A', Pink: '#E3B5B5', Blue: '#7D9BB8' };
  var ICON_OK = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="10" cy="10" r="8.5" stroke-width="1.3"/><path d="M6.2 10.3l2.5 2.4 5-5.2"/></svg>';
  var ICON_MISS = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><circle cx="10" cy="10" r="8.5"/><path d="M6.5 10h7"/></svg>';
  var ICON_INFO = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><rect x="2" y="7" width="16" height="6" rx="1"/><path d="M6 7v3M10 7v3M14 7v3"/></svg>';
  var ICON_TICK = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M3.5 8.4l3 2.8 6-6.4"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function track(name, params) { if (typeof gtag === 'function') gtag('event', name, params); }

  /* ---------- productos → modelos (colores agrupados por item_group_id + medidas) ---------- */
  function buildModels(products) {
    var map = {}, list = [];
    products.forEach(function (p) {
      var base = p.title.replace(COLOR_SUFFIX, '');
      var key = (p.group || p.handle) + '|' + p.h + '|' + p.w + '|' + p.l + '|' + base.toLowerCase();
      var m = map[key];
      if (!m) {
        m = map[key] = { title: base, who: p.who || '', h: p.h, w: p.w, l: p.l, load: p.load || null, variants: [] };
        m.width = Math.max(p.w, p.l); m.depth = Math.min(p.w, p.l); m.fp = p.w * p.l;
        list.push(m);
      }
      m.variants.push(p);
    });
    // Solo se recomiendan colores con stock; un modelo sin ningún color disponible no entra en el quiz
    list.forEach(function (m) {
      m.variants = m.variants.filter(function (v) { return v.available; });
      m.colors = m.variants.map(function (v) { return v.color; }).filter(Boolean);
      m.price = m.variants.length ? Math.min.apply(null, m.variants.map(function (v) { return v.price; })) : 0;
    });
    return list.filter(function (m) { return m.variants.length; });
  }

  /* ---------- reglas: "A AND B OR C" · campo~regex · campo!~regex · campo=valor · campo>=n · n[regex]>=n · any ---------- */
  function field(m, f) {
    if (f === 'title') return m.title;
    if (f === 'who') return m.who;
    if (f === 'price') return m.price / 100;
    return m[f];
  }
  function testCond(m, c) {
    c = c.trim();
    if (!c || c === 'any') return true;
    var r;
    if ((r = c.match(/^(\w+)(!?)~(.+)$/))) {
      var re = new RegExp(r[3], 'i');
      var hit = r[1] === 'color' ? m.colors.some(function (x) { return re.test(x); }) : re.test(field(m, r[1]) || '');
      return r[2] ? !hit : hit;
    }
    if ((r = c.match(/^n\[(.+)\](>=|<=|>|<|=)([\d.]+)$/))) {
      var mm = m.title.match(new RegExp(r[1], 'i'));
      if (!mm) return false;
      return cmp(parseFloat(mm[1]), r[2], parseFloat(r[3]));
    }
    if ((r = c.match(/^(\w+)(>=|<=|>|<)([\d.]+)$/))) return cmp(field(m, r[1]), r[2], parseFloat(r[3]));
    if ((r = c.match(/^(\w+)=(.+)$/))) {
      var val = r[2].trim().toLowerCase();
      if (r[1] === 'color') return m.colors.some(function (x) { return String(x).toLowerCase() === val; });
      return String(field(m, r[1]) || '').toLowerCase() === val;
    }
    return false;
  }
  function cmp(a, op, b) {
    if (a == null || isNaN(a)) return false;
    return op === '>=' ? a >= b : op === '<=' ? a <= b : op === '>' ? a > b : op === '<' ? a < b : a === b;
  }
  function test(m, rule) {
    return String(rule || 'any').split(/\s+OR\s+/).some(function (g) {
      return g.split(/\s+AND\s+/).every(function (c) { return testCond(m, c); });
    });
  }
  function fill(tpl, m, rule) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (_, k) {
      if (k === 'cap') { var re = String(rule || '').match(/n\[(.+?)\](?:>=|<=|>|<|=)/); var c = re && m.title.match(new RegExp(re[1], 'i')); return c ? c[1] : ''; }
      if (k === 'price') return money(m.price);
      if (k === 't1') return (m.title.match(/\d+/) || [''])[0];
      var v = m[k]; return v == null ? '' : (Math.round(v * 10) / 10);
    });
  }

  /* ---------- ranking: la 1ª pregunta pesa más que el resto juntas ---------- */
  function rank(models, qs, answers) {
    return models.map(function (m) {
      var score = 0, lines = [];
      qs.forEach(function (q) {
        var o = q.options[answers[q.key]]; if (!o) return;
        var ok = test(m, o.rule); if (ok) score += q.weight;
        var text = ok ? fill(o.fit, m, o.rule) : fill(o.miss, m, o.rule);
        if (text) lines.push({ ok: ok, text: text, w: q.weight });
      });
      lines.sort(function (a, b) { return (b.ok - a.ok) || (b.w - a.w); });
      return { m: m, score: score, lines: lines };
    }).sort(function (a, b) { return (b.score - a.score) || (a.m.price - b.m.price); });
  }

  /* ---------- visual de cada opción ---------- */
  function visual(v) {
    if (!v) return '';
    if (v.type === 'product' && v.img) return '<span class="ch-pf-opt__vis is-photo"><img src="' + esc(v.img) + '" alt="" loading="lazy"></span>';
    if (v.type === 'pair' && v.img) return '<span class="ch-pf-opt__vis"><span class="ch-pf-opt__thumbs"><span><img src="' + esc(v.img) + '" alt="" loading="lazy"></span>' + (v.img2 ? '<span><img src="' + esc(v.img2) + '" alt="" loading="lazy"></span>' : '') + '</span></span>';
    if (v.type === 'svg' && v.svg) return '<span class="ch-pf-opt__vis"><span class="ch-pf-opt__ill">' + v.svg + '</span></span>';
    if (v.type === 'bench' && v.bench) {
      var d = v.bench.split(/x|×/i), w = +d[0] || 30, l = +d[1] || 30;
      return '<span class="ch-pf-opt__vis"><svg class="ch-pf-opt__bench" viewBox="0 0 160 110" aria-hidden="true"><rect x="2" y="6" width="156" height="98" rx="3" class="ch-pf-svg-paper"/><rect x="108" y="18" width="42" height="74" rx="6" class="ch-pf-svg-sink"/><circle cx="129" cy="28" r="3" class="ch-pf-svg-tap"/><rect x="' + (102 - w * 1.4) + '" y="' + (55 - l * 0.7) + '" width="' + (w * 1.4) + '" height="' + (l * 1.4) + '" rx="2" class="ch-pf-svg-accent"/><text x="' + (102 - w * 0.7) + '" y="59" text-anchor="middle" class="ch-pf-svg-label-light">' + w + '×' + l + '</text></svg></span>';
    }
    return '';
  }

  /* ---------- piezas propias por tipo de producto ---------- */
  var SIGNATURES = {
    // Encimera vista desde arriba: base de cada modelo a escala
    footprint: function (models) {
      // Los de encima del fregadero no ocupan encimera: fuera del gráfico
      var ms = models.filter(function (m) { return !/over (the )?sink/i.test(m.title); }).sort(function (a, b) { return a.fp - b.fp; });
      var S = 2.2, depth = 60 * S, gap = 14, x = 20, s = '';
      ms.forEach(function (m) {
        var w = m.w * S, l = m.l * S;
        s += '<rect x="' + x + '" y="' + (40 + depth - l) + '" width="' + w + '" height="' + l + '" rx="2" class="ch-pf-svg-accent"/>' +
          '<text x="' + (x + w / 2) + '" y="' + (34 + depth - l) + '" text-anchor="middle" class="ch-pf-svg-label">' + m.w + '×' + m.l + '</text>';
        x += w + gap;
      });
      var W = x + 10;
      return { viewBox: '0 0 ' + W + ' ' + (40 + depth + 14), minWidth: 900,
        body: '<rect x="10" y="40" width="' + (W - 20) + '" height="' + depth + '" class="ch-pf-svg-bench"/><text x="14" y="28" class="ch-pf-svg-note">60 cm deep benchtop, seen from above</text>' + s };
    },
    // Frentes a escala: ancho × alto real y número de cajones
    drawer_fronts: function (models) {
      var ms = models.slice().sort(function (a, b) { return (a.width * a.h) - (b.width * b.h); });
      var S = 2.1, base = 250, x = 24, s = '';
      ms.forEach(function (m) {
        var n = parseInt((m.title.match(/(\d+)\s*Drawer/i) || [0, 3])[1], 10);
        var cols = m.width >= 70 ? 2 : 1, rows = Math.ceil(n / cols);
        var w = m.width * S, h = m.h * S, top = base - h, oak = /oak/i.test(m.title);
        var inner = 6, dh = (h - inner * 2 - 8) / rows, dw = (w - inner * 2 - (cols - 1) * 4) / cols;
        s += '<rect x="' + x + '" y="' + top + '" width="' + w + '" height="' + h + '" rx="2" class="' + (oak ? 'ch-pf-svg-oak' : 'ch-pf-svg-steel') + '"/>';
        for (var c = 0; c < cols; c++) for (var r = 0; r < rows; r++) {
          var dx = x + inner + c * (dw + 4), dy = top + inner + 8 + r * dh;
          s += '<rect x="' + dx + '" y="' + dy + '" width="' + dw + '" height="' + (dh - 4) + '" rx="1.5" class="ch-pf-svg-drawer"/><rect x="' + (dx + dw / 2 - 6) + '" y="' + (dy + (dh - 4) / 2 - 1.5) + '" width="12" height="3" rx="1.5" class="ch-pf-svg-handle"/>';
        }
        s += '<text x="' + (x + w / 2) + '" y="' + (top - 8) + '" text-anchor="middle" class="ch-pf-svg-label">' + n + ' · ' + Math.round(m.width) + ' cm</text>';
        x += w + 18;
      });
      return { viewBox: '0 0 ' + (x + 10) + ' 290', minWidth: 900,
        body: '<line x1="10" x2="' + x + '" y1="' + base + '" y2="' + base + '" class="ch-pf-svg-floor"/><text x="14" y="' + (base + 24) + '" class="ch-pf-svg-note">Front view to scale · drawers · width</text>' + s };
    },
    // Siluetas de frente a escala (ancho × alto) sobre el suelo
    front_scale: function (models, box) {
      var key = box.dataset.chPfRegex === 'w' ? 'w' : 'width';
      var ms = models.slice().sort(function (a, b) { return a[key] - b[key] || a.h - b.h; });
      // Escala: el más alto llena el alto disponible sin que la fila pase de ~1100 px; el alto del gráfico sale del contenido
      var maxH = Math.max.apply(null, ms.map(function (m) { return m.h; }));
      var sumW = ms.reduce(function (a, m) { return a + Math.max(m[key], 10); }, 0);
      var S = Math.min(230 / maxH, (1100 - ms.length * 16) / sumW), base = Math.round(maxH * S) + 34, x = 24, s = '';
      ms.forEach(function (m) {
        var w = Math.max(m[key] * S, 14), h = Math.max(m.h * S, 4);
        s += '<rect x="' + x + '" y="' + (base - h) + '" width="' + w + '" height="' + h + '" rx="2" class="ch-pf-svg-accent"/>' +
          '<text x="' + (x + w / 2) + '" y="' + (base - h - 7) + '" text-anchor="middle" class="ch-pf-svg-label">' + Math.round(m[key]) + '×' + Math.round(m.h) + '</text>';
        x += w + 16;
      });
      return { viewBox: '0 0 ' + (x + 10) + ' ' + (base + 32), minWidth: Math.min(900, x + 10),
        body: '<line x1="10" x2="' + x + '" y1="' + base + '" y2="' + base + '" class="ch-pf-svg-floor"/><text x="14" y="' + (base + 22) + '" class="ch-pf-svg-note">Front view to scale · width × height in cm</text>' + s };
    },
    // Barras de capacidad: número sacado del título (botellas, accesorios…)
    number_bars: function (models, box) {
      var re = new RegExp(box.dataset.chPfRegex || '(\\d+)', 'i'), unit = box.dataset.chPfUnit || '';
      var rows = models.map(function (m) { var r = m.title.match(re); return r ? { m: m, n: parseFloat(r[1]) } : null; })
        .filter(Boolean).sort(function (a, b) { return a.n - b.n; });
      var max = Math.max.apply(null, rows.map(function (r) { return r.n; })), y = 10, s = '';
      rows.forEach(function (r) {
        var w = (r.n / max) * 520;
        s += '<text x="0" y="' + (y + 15) + '" class="ch-pf-svg-label">' + r.n + ' ' + unit + '</text>' +
          '<rect x="110" y="' + y + '" width="' + w + '" height="20" rx="2" class="ch-pf-svg-accent"/>' +
          '<text x="' + (120 + w) + '" y="' + (y + 15) + '" class="ch-pf-svg-note">' + r.m.title.replace(/\s*[-–]\s.*$/, '').slice(0, 58) + '</text>';
        y += 32;
      });
      return { viewBox: '0 0 1040 ' + (y + 6), minWidth: 760, body: s };
    },
    // Alturas frente a un techo de 2,4 m
    height_scale: function (models) {
      var ms = models.slice().sort(function (a, b) { return a.h - b.h; });
      var base = 250, top = 20, y = function (h) { return base - (h / 300) * (base - top); }, step = 70, x = 50, s = '';
      ms.forEach(function (m) {
        s += '<rect x="' + x + '" y="' + y(m.h) + '" width="30" height="' + (base - y(m.h)) + '" rx="2" class="ch-pf-svg-accent"/><text x="' + (x + 15) + '" y="' + (y(m.h) - 6) + '" text-anchor="middle" class="ch-pf-svg-label">' + m.h + '</text>';
        x += step;
      });
      return { viewBox: '0 0 ' + (x + 20) + ' 280', minWidth: 760,
        body: '<line x1="30" x2="' + x + '" y1="' + base + '" y2="' + base + '" class="ch-pf-svg-floor"/><line x1="30" x2="' + x + '" y1="' + y(240) + '" y2="' + y(240) + '" class="ch-pf-svg-ceiling"/><text x="34" y="' + (y(240) - 6) + '" class="ch-pf-svg-note">2.4 m ceiling</text>' + s };
    }
  };

  /* ---------- componente ---------- */
  function Finder(root) {
    var cfg = JSON.parse(root.querySelector('[data-ch-pf-config]').textContent);
    this.root = root; this.cfg = cfg; this.qs = cfg.questions;
    this.models = buildModels(cfg.products);
    this.stage = root.querySelector('[data-ch-pf-stage]');
    this.state = { step: 0, answers: {} };
    this.qs.forEach(function (q) { q.options.forEach(function (o) { o.n = this.models.filter(function (m) { return test(m, o.rule); }).length; }, this); }, this);
    this.render();
    this.signature();
    var start = root.querySelector('[data-ch-pf-start]');
    if (start) start.addEventListener('click', function (e) { e.preventDefault(); root.querySelector('[data-ch-pf-quiz]').scrollIntoView({ behavior: 'smooth' }); });
  }

  Finder.prototype.steps = function (done) {
    var st = this.state.step;
    return '<ol class="ch-pf-steps">' + this.qs.map(function (q, i) {
      var cls = done || i < st ? 'is-done' : i === st ? 'is-on' : '';
      return '<li class="' + cls + '">' + (i + 1) + '. ' + esc(q.step) + '</li>';
    }).join('') + '</ol>';
  };

  Finder.prototype.render = function () {
    var self = this, st = this.state;
    if (st.step >= this.qs.length) return this.results();
    var q = this.qs[st.step], unit = this.cfg.unit || ['product', 'products'];
    this.stage.innerHTML = this.steps() +
      '<h2 class="ch-pf-q__title">' + esc(q.title) + '</h2>' + (q.help ? '<p class="ch-pf-q__help">' + esc(q.help) + '</p>' : '') +
      '<div class="ch-pf-opts">' + q.options.map(function (o, i) {
        if (!o.n) return '';
        return '<button type="button" class="ch-pf-opt" data-i="' + i + '" aria-pressed="' + (st.answers[q.key] === i) + '"><span class="ch-pf-opt__tick">' + ICON_TICK + '</span>' + visual(o.visual) +
          '<span class="ch-pf-opt__txt"><span class="ch-pf-opt__label">' + esc(o.label) + '</span>' + (o.sub ? '<span class="ch-pf-opt__sub">' + esc(o.sub) + '</span>' : '') +
          '<span class="ch-pf-opt__count">' + o.n + ' ' + (o.n === 1 ? unit[0] : unit[1]) + '</span></span></button>';
      }).join('') + '</div>' +
      '<div class="ch-pf-q__nav">' + (st.step ? '<button type="button" class="ch-pf-link" data-ch-pf-back>Back</button>' : '') + '</div>';
    this.stage.querySelectorAll('.ch-pf-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        if (st.step === 0 && st.answers[q.key] == null) track('finder_start', { finder: self.cfg.name });
        st.answers[q.key] = +b.dataset.i;
        self.stage.querySelectorAll('.ch-pf-opt').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        setTimeout(function () { st.step++; self.render(); }, 220);
      });
    });
    var back = this.stage.querySelector('[data-ch-pf-back]');
    if (back) back.addEventListener('click', function () { st.step--; self.render(); });
  };

  Finder.prototype.results = function () {
    var self = this, cfg = this.cfg, answers = this.state.answers;
    // Si una respuesta elige color, cada modelo enseña primero ese color (foto, precio y enlace)
    var pref = null;
    this.qs.forEach(function (q) { var o = q.options[answers[q.key]]; var r = o && String(o.rule).match(/^color=(\w+)$/i); if (r) pref = r[1].toLowerCase(); });
    this.models.forEach(function (m) {
      m.variants.sort(function (a, b) { return (String(b.color).toLowerCase() === pref) - (String(a.color).toLowerCase() === pref); });
    });
    var ranked = rank(this.models, this.qs, answers), top = ranked.slice(0, 3);
    var max = this.qs.reduce(function (a, q) { return a + q.weight; }, 0), exact = top[0] && top[0].score === max;
    var chips = this.qs.map(function (q) { return '<span class="ch-pf-chip">' + esc(q.options[answers[q.key]].label) + '</span>'; }).join('');
    track('finder_complete', { finder: cfg.name, exact_match: exact ? 'yes' : 'no' });
    var cards = cfg.results === 'columns'
      ? '<div class="ch-pf-cols">' + top.map(function (r, i) { return self.card(r, 'col', i === 0 ? (exact ? cfg.badge : cfg.badge_close) : ''); }).join('') + '</div>'
      : this.card(top[0], 'best', exact ? cfg.badge : cfg.badge_close) + '<p class="ch-pf-alts__title">' + esc(cfg.alts_title) + '</p><div class="ch-pf-alts">' + top.slice(1).map(function (r) { return self.card(r, 'alt', ''); }).join('') + '</div>';
    this.stage.innerHTML = this.steps(true) +
      '<div class="ch-pf-res__head"><div><p class="ch-pf-eyebrow">' + esc(cfg.results_eyebrow) + '</p><h2 class="ch-pf-q__title">' + esc(cfg.results_title) + '</h2><div class="ch-pf-chips">' + chips + '</div></div>' +
      '<button type="button" class="ch-pf-link" data-ch-pf-restart>' + esc(cfg.restart) + '</button></div>' +
      (exact ? '' : '<p class="ch-pf-notice">' + esc(cfg.closest_note) + '</p>') + cards +
      '<div class="ch-pf-res__foot"><a class="ch-pf-btn is-ghost" href="' + esc(cfg.all_url) + '">' + esc(cfg.all_label) + '</a></div>';
    this.stage.querySelector('[data-ch-pf-restart]').addEventListener('click', function () {
      self.state = { step: 0, answers: {} }; self.render(); self.root.querySelector('[data-ch-pf-quiz]').scrollIntoView({ behavior: 'smooth' });
    });
    this.stage.querySelectorAll('[data-ch-pf-card]').forEach(function (el) { self.bindCard(el, ranked); });
  };

  Finder.prototype.card = function (r, kind, badge) {
    if (!r) return '';
    var m = r.m, v = m.variants[0], cfg = this.cfg;
    var info = cfg.info_line ? '<li class="is-info">' + ICON_INFO + '<span>' + esc(fill(cfg.info_line, m)) + '</span></li>' : '';
    return '<article class="ch-pf-card is-' + kind + '" data-ch-pf-card data-key="' + esc(m.title + m.h + m.w) + '">' +
      '<a class="ch-pf-card__img" href="' + esc(v.url) + '" data-ch-pf-link>' + (badge ? '<span class="ch-pf-badge">' + esc(badge) + '</span>' : '') + '<img src="' + esc(v.img) + '" alt="' + esc(m.title) + '" loading="lazy"></a>' +
      '<div class="ch-pf-card__body"><h3 class="ch-pf-card__title"><a href="' + esc(v.url) + '" data-ch-pf-link>' + esc(m.title) + '</a></h3>' + this.price(v) + this.swatches(m) +
      '<ul class="ch-pf-fit">' + r.lines.map(function (l) { return '<li class="' + (l.ok ? '' : 'is-miss') + '">' + (l.ok ? ICON_OK : ICON_MISS) + '<span>' + esc(l.text) + '</span></li>'; }).join('') + info + '</ul>' +
      '<a class="ch-pf-btn' + (kind === 'alt' ? ' is-ghost' : '') + '" href="' + esc(v.url) + '" data-ch-pf-link>' + esc(cfg.cta) + '</a></div></article>';
  };
  Finder.prototype.price = function (v) {
    var off = v.compare > v.price ? Math.round((1 - v.price / v.compare) * 100) : 0;
    return '<p class="ch-pf-price"><b>' + money(v.price) + '</b>' + (off ? '<s>' + money(v.compare) + '</s><span class="ch-pf-price__off">-' + off + '%</span>' : '') + '</p>';
  };
  Finder.prototype.swatches = function (m) {
    if (m.variants.length < 2) return '';
    return '<div class="ch-pf-swatches">' + m.variants.map(function (v, j) {
      return '<button type="button" class="ch-pf-sw" aria-label="' + esc(v.color) + '" aria-pressed="' + (j === 0) + '" data-j="' + j + '" style="background:' + (SWATCH[v.color] || '#ccc') + '"></button>';
    }).join('') + '<span>' + m.variants.map(function (v) { return esc(v.color); }).join(' / ') + '</span></div>';
  };
  Finder.prototype.bindCard = function (el, ranked) {
    var self = this, r = ranked.filter(function (x) { return (x.m.title + x.m.h + x.m.w) === el.dataset.key; })[0];
    if (!r) return;
    el.querySelectorAll('.ch-pf-sw').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var v = r.m.variants[+sw.dataset.j];
        el.querySelector('img').src = v.img;
        el.querySelectorAll('[data-ch-pf-link]').forEach(function (a) { a.href = v.url; });
        el.querySelector('.ch-pf-price').outerHTML = self.price(v);
        el.querySelectorAll('.ch-pf-sw').forEach(function (s) { s.setAttribute('aria-pressed', s === sw); });
      });
    });
    el.querySelectorAll('[data-ch-pf-link]').forEach(function (a) {
      a.addEventListener('click', function () { track('finder_product_click', { finder: self.cfg.name, product: r.m.title }); });
    });
  };

  Finder.prototype.signature = function () {
    var box = this.root.querySelector('[data-ch-pf-signature]');
    if (!box || !SIGNATURES[box.dataset.chPfSignature]) return;
    var g = SIGNATURES[box.dataset.chPfSignature](this.models, box);
    var svg = box.querySelector('svg');
    svg.setAttribute('viewBox', g.viewBox); svg.style.minWidth = g.minWidth + 'px'; svg.innerHTML = g.body;
  };

  function init() { document.querySelectorAll('[data-ch-finder]').forEach(function (el) { if (!el.chFinder) el.chFinder = new Finder(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
